import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login/login'
import repassword from '../views/login/repassword'
import register from '../views/login/register'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/repassword',
      name: 'repassword',
      component: repassword
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/nav',
      name: 'nav',
      component: () =>
        import("../views/nav/elnav"),
      children: [
        {
          path: "/",
          name: "report",
          component: () =>
            import("../views/business/report")
        },
        {
          path: "/nav/video",
          name: "video",
          component: () =>
            import("../views/business/video")
        },
        {
          path: "/nav/job",
          name: "setjob",
          component: () =>
            import("../views/job/setjob")
        },
        {
          path: "/nav/joborder",
          name: "joborder",
          component: () =>
            import("../views/job/job-order")
        },
        {
          path: "/nav/joblist",
          name: "joblist",
          component: () =>
            import("../views/job/job-list")
        },
        {
          path: "/nav/jobrate",
          name: "jobrate",
          component: () =>
            import("../views/job/job-rate")
        },
        {
          path: "/nav/jobprice",
          name: "jobprice",
          component: () =>
            import("../views/job/job-price")
        },
        {
          path: "/nav/jobmodel",
          name: "jobmodel",
          component: () =>
            import("../views/job/job-model")
        },
        {
          path: "/nav/watchjob",
          name: "watchjob",
          component: () =>
            import("../views/watch/watch-job")
        },
        {
          path: "/nav/salemanage",
          name: "salemanage",
          component: () =>
            import("../views/sale/sale-manage")
        },
        {
          path: "/nav/shopmanage",
          name: "shopmanage",
          component: () =>
            import("../views/shop/shop-manage")
        },
        {
          path: "/nav/rechargeout",
          name: "rechargeout",
          component: () =>
            import("../views/recharge/recharge-out")
        },
		{
		  path: "/nav/rechargepay",
		  name: "rechargepay",
		  component: () =>
		    import("../views/recharge/rechargepay")
		},
        {
          path: "/nav/rechargelist",
          name: "rechargelist",
          component: () =>
            import("../views/recharge/recharge-list")
        },
        {
          path: "/nav/rechargebind",
          name: "rechargebind",
          component: () =>
            import("../views/recharge/recharge-bind")
        },
        {
          path: "/nav/rechargehistory",
          name: "rechargehistory",
          component: () =>
            import("../views/recharge/recharge-history")
        },
        {
          path: "/nav/appealcenter",
          name: "appealcenter",
          component: () =>
            import("../views/appeal/appeal-center")
        },
        {
          path: "/nav/invitefriend",
          name: "invitefriend",
          component: () =>
            import("../views/invite/invite-friend")
        },
        {
          path: "/nav/inviteback",
          name: "inviteback",
          component: () =>
            import("../views/invite/invite-back")
        },
        {
          path: "/nav/blacklist",
          name: "blacklist",
          component: () =>
            import("../views/black/black-list")
        },
        {
          path: "/nav/giftshop",
          name: "giftshop",
          component: () =>
            import("../views/gift/gift-shop")
        },
        {
          path: "/nav/gifthistory",
          name: "gifthistory",
          component: () =>
            import("../views/gift/gift-history")
        },
        {
          path: "/nav/magicsearch",
          name: "magicsearch",
          component: () =>
            import("../views/magic/magic-search")
        },
        {
          path: "/nav/jobdetail",
          name: "jobdetail",
          component: () =>
            import("../views/job/job-orderdetail")
        },
        {
          path: "/nav/modeldetail",
          name: "modeldetail",
          component: () =>
            import("../views/job/model-detail")
        },
		{
		  path: "/nav/taobao",
		  name: "viewtaobao",
		  component: () =>
		    import("../views/view/taobao")
		},
		{
		  path: "/nav/jingdong",
		  name: "viewjingdong",
		  component: () =>
		    import("../views/view/jingdong")
		},
		{
		  path: "/nav/pinduoduo",
		  name: "viewpinduoduo",
		  component: () =>
		    import("../views/view/pinduoduo")
		},
		{
		  path: "/nav/douyin",
		  name: "viewdouyin",
		  component: () =>
		    import("../views/view/douyin")
		},
		{
		  path: "/nav/viewtask",
		  name: "viewtask",
		  component: () =>
		    import("../views/view/viewtask")
		}
      ]
    },
  ]
})

export default router

router.beforeEach((to, from, next) => {
  // 1.如果访问的是登录页面（无需权限），直接放行
  if (to.path === '/' || to.path === '/register' || to.path === '/repassword') return next()
  // 2.如果访问的是有登录权限的页面，先要获取token
  const tokenStr = window.localStorage.getItem('Authorization')
  // 2.1如果token为空，强制跳转到登录页面；否则，直接放行
  if (!tokenStr) {
    return next('/')
  }
  next()
})
